import { Injectable } from '@angular/core';
import { BBResponseContainer } from '../common-services/response-container';
import { environment } from '../../environments/environment';
import { timeout, catchError, map } from 'rxjs/operators';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { CalculatePlanDTO } from './models/runPlanConstants';

@Injectable()
export class RunPlanMainViewService {
    
    defaultTimeout = 600000;
    
    constructor(private http: HttpClient) { }
    
    getBatchesForLab(sequencerType: string, labId: string, status: string, constraint: string): Observable<BBResponseContainer> {
        let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/librarydata";
        let requestParam = new HttpParams().set('sequencerType', sequencerType).set('labId', labId).set('status', status);
        if(constraint) {
            requestParam = requestParam.set('constraint', constraint);
        }
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }
    
    createIPU(sequencerType: string, labId: string, status: string, calculatePlanDTO: CalculatePlanDTO) {
        let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/calculate";
        let requestParam = new HttpParams().set('labId', labId).set('status', status).set('sequencerType', sequencerType); 
        const options = url ? { params: requestParam } : {};
        return this.http.post<BBResponseContainer>(url, calculatePlanDTO, options).pipe(timeout(environment.defaultTimeout));
    }
    
    deleteIPUs(labId: string): Observable<BBResponseContainer> {
        let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/delete";
        let requestParam = new HttpParams().set('labId', labId); 
        const options = url ? { params: requestParam } : {};
        return this.http.put<BBResponseContainer>(url, {}, options).pipe(timeout(environment.defaultTimeout));
    }
    
    //Gets a list of machinetypes for selected Lab
    getSequencerMachines(labName:string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + "mdm/machinetype/sequencer";
        let requestParam = new HttpParams().set('labName', labName);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }
    
    getFlowcellCapacity(labId: string, sequencer:string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + "mdm/flowcell/getCapacity/" + labId + "/" + sequencer;
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
    }

    getConstraintInfo(labId: string, libraryIds: string[]): Observable<BBResponseContainer> {
        let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/constraintId/list/" + labId;
        return this.http.put<BBResponseContainer>(url, libraryIds).pipe(timeout(environment.defaultTimeout));
    }

    publishRunPlan(run: any) {
        let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/publish";
        return this.http.post<BBResponseContainer>(url, run).pipe(timeout(environment.defaultTimeout));
    }

    balanceLanes(requestObj: any) {
        let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/lane/balance";
        return this.http.put<BBResponseContainer>(url, requestObj).pipe(timeout(environment.defaultTimeout));
    }

    exportRunPlan(jsonString: any) {
        let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/exportExcel";
        return this.http.put(url, jsonString, { observe: 'response', responseType: 'blob' }).pipe(
            timeout(environment.defaultTimeout),
            map((res) => {
                return {
                  fileContent: new Blob([res.body], { type: res.headers.get('content-Type') }),
                  filename: res.headers.get('filename')
                };
              }),catchError(error => throwError(error.message)));
    }

    getRunsDataGroupedByReadMode(labId: string, selectedSequencer: string, selectedTagLength: string) {
        let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/replan/runs";
        let requestParam = new HttpParams().set('labId', labId).set('sequencerType', selectedSequencer).set('tagLength', selectedTagLength); 
        const options = { params: requestParam } ;
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }
}